import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

// import JS files
import MuiButton from "../../../shares/MuiButton";
import RemoveModal from "../../../shares/RemoveModal";
import EditRing from "./EditRing";
import { toast } from "react-toastify";
import useFetch from "../../../../context/useFetch";
import MuiModal from "../../../shares/MuiModal";
import RingsSizeShow from "../../../shares/RingsSizeShow";

// import Others files
import sampleImg from "../../../../imgs/sample-ring.png";

const RingCard = (props) => {
  let windowWidth = window.screen.width;

  const [openRingsSizeShowModal, setOpenRingsSizeShowModal] = useState(false);
  const handleRingsSizeShowModal = () => {
    setOpenRingsSizeShowModal((before) => !before);
  };

  const [openEditRingModal, setOpenEditRingModal] = useState(false);
  const handleEditRingModal = () => {
    setOpenEditRingModal((before) => !before);
  };

  const [openRemoveRingModal, setOpenRemoveRingModal] = useState(false);
  const handleRemoveRingModal = () => {
    setOpenRemoveRingModal((before) => !before);
  };
  const [ringIsCheck, setRingIsCheck] = useState(props.item.is_active);

  const UpdateBangleApi = useFetch({
    method: "patch",
    url: `Bangle_Service/${props.item.id}`,
    data: { is_active: ringIsCheck , can_edit: true },
    trigger: false,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      // toast.success("تغییر وضعیت با موفقیت انجام شد ", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const handle_switch_change = (event) => {
    setRingIsCheck(event.target.checked);
    UpdateBangleApi.reFetch();
  };
  const RemoveBangleApi = useFetch({
    method: "delete",
    url: `Bangle_Service/${props.item.id}`,

    trigger: false,
    argFunc: (res) => {
      props.getRingsApi.reFetch();
      // toast.success("النگو موردنظر با موفقیت حذف شد", {
      //   position: toast.POSITION.TOP_CENTER,
      // });
      setOpenRemoveRingModal(false)
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });
  return (
    <>
      <div className="panel-card">
        <div className="absolute bg-slate-100 rounded-lg py-1 px-4">
          <span className="text-xs md:text-sm">
            {props.item.gender == "woman" ? "زنانه" : "بچگانه"}
          </span>
        </div>
        {props.item.color == "yellow" ? (
          <div className="absolute bg-yellow-400 rounded-md py-1 px-4	left-4">
            <span className="text-xs md:text-sm">زرد</span>
          </div>
        ) : (
          <div className="absolute bg-Indigo-50 border border-slate-200 rounded-md py-1 px-4	left-4">
            <span className="text-xs md:text-sm">سفید</span>
          </div>
        )}

        <div className="flex justify-center mb-8">
          
          {props.item.attach_file == "EMPTY" ? (
            <img
              className="w-20 h-20 md:w-32 md:h-32 rounded-full"
              src={sampleImg}
            />
          ) : (
            <img
              className="w-28 h-28 md:w-32 md:h-32 rounded-full"
              src={props.item.attach_file}
            />
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="show-label	">
            کد: <span className="show-value	"> {props.item.code}</span>
          </span>
          <span className="show-label">
            اسم: <span className="show-value"> {props.item.show_name}</span>
          </span>
          <span className="show-label">
            برند: <span className="show-value	"> {props.item.brand_name}</span>
          </span>
        </div>
        <div className="flex items-center justify-between mt-6">
          <MuiButton
            onClick={handleRingsSizeShowModal}
            variant="outlined"
            color="secondary"
            text="مشاهده وزن‌ها"
            size="small"
          />
          {openRingsSizeShowModal && (
            <MuiModal
              openModal={openRingsSizeShowModal}
              setOpenModal={setOpenRingsSizeShowModal}
              width="w-3/5"
            >
              <RingsSizeShow
                w1={props.item.size_one_weight}
                w2={props.item.size_two_weight}
                w3={props.item.size_three_weight}
                w4={props.item.size_four_weight}
                w5={props.item.size_five_weight}
                w6={props.item.size_six_weight}
                code={props.item.code}
                show_name={props.item.show_name}
                brand={props.item.brand_name}
                gender={props.item.gender}
                color={props.item.color}
              />
            </MuiModal>
          )}
          <div className="flex items-center">
            <span className="text-xs md:text-sm">قابل سفارش:</span>
            <Switch onChange={handle_switch_change} checked={ringIsCheck} />
          </div>
        </div>
        <div className="flex  justify-between mt-6">
          <div className="edit-icon" onClick={() => handleEditRingModal()}>
            <EditIcon />
          </div>
          {openEditRingModal && (
            <EditRing
              openModal={openEditRingModal}
              setOpenModal={setOpenEditRingModal}
              getRingsApi={props.getRingsApi}
              item={props.item}
            />
          )}
          <div className="delete-icon" onClick={() => handleRemoveRingModal()}>
            <DeleteIcon />
          </div>
          {openRemoveRingModal && (
            <RemoveModal
              openModal={openRemoveRingModal}
              setOpenModal={setOpenRemoveRingModal}
              onClick={() => RemoveBangleApi.reFetch()}
              text="آیا از حذف النگوی موردنظر اطمینان دارید؟"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default RingCard;
